import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import { API_ROUTES } from 'src/routes/api';
import { DEFAULT_PAGE_SIZE } from 'src/config';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  isReviewsLoading: false,
  error: false,
  reviewsList: {
    data: [],
    pagination: {}
  }
};

const slice = createSlice({
  name: 'reviews',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
      state.error = false;
    },

    startReviewsLoading(state) {
      state.isReviewsLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET REVIEWS
    getReviewsSuccess(state, action) {
      state.isLoading = false;
      state.isReviewsLoading = false;
      state.reviewsList = {
        data: action.payload.reviews,
        pagination: action.payload.meta.pagination
      };
    },

    reset(state) {
      Object.keys(state).forEach((key) => (state[key] = initialState[key]));
    }
  }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getReviewsList(page = 1, page_size = DEFAULT_PAGE_SIZE) {
  return async (dispatch) => {
    dispatch(slice.actions.startReviewsLoading());
    dispatch(slice.actions.startLoading());

    try {
      const {
        data: { reviews, meta }
      } = await axios.get(API_ROUTES.reviews.index, {
        params: {
          page,
          page_size
        }
      });

      dispatch(slice.actions.getReviewsSuccess({ reviews, meta }));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function reset() {
  return async (dispatch) => {
    dispatch(slice.actions.reset());
  };
}
